/* istanbul ignore file */
// we don't test SVGs without arguments
import React from 'react'

const IconCircle = ({ color = '#EEF0F2', radius = 13 }) => (
  <svg
    height={`${radius * 2}px`}
    version="1.1"
    viewBox={`0 0 ${radius * 2} ${radius * 2}`}
    width={`${radius * 2}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <circle cx={radius} cy={radius} fill={color} r={radius} />
      <g
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.82"
        transform="translate(7.000000, 8.000000)"
      />
    </g>
  </svg>
)

export default IconCircle
